var map = {
	"../chicken-center-add/chicken-center-add.module": [
		"./src/app/chicken-center-add/chicken-center-add.module.ts",
		"chicken-center-add-chicken-center-add-module"
	],
	"../dealer-review/dealer-review.module": [
		"./src/app/dealer-review/dealer-review.module.ts",
		"dealer-review-dealer-review-module"
	],
	"../layers-inventory/layers-inventory-summary/layers-inventory-summary.module": [
		"./src/app/layers-inventory/layers-inventory-summary/layers-inventory-summary.module.ts",
		"layers-inventory-layers-inventory-summary-layers-inventory-summary-module"
	],
	"../layers-sales/layers-sales.module": [
		"./src/app/layers-sales/layers-sales.module.ts",
		"layers-sales-layers-sales-module"
	],
	"../lease-details/lease-details.module": [
		"./src/app/lease/lease-details/lease-details.module.ts",
		"lease-details-lease-details-module"
	],
	"../lease/lease.module": [
		"./src/app/lease/lease/lease.module.ts"
	],
	"../lifting-supervisor/lifting-supervisor.module": [
		"./src/app/lifting-supervisor/lifting-supervisor.module.ts",
		"lifting-supervisor-lifting-supervisor-module"
	],
	"../linked-contacts/linked-contacts.module": [
		"./src/app/linked-contacts/linked-contacts.module.ts",
		"linked-contacts-linked-contacts-module"
	],
	"../pastorders/pastorders.module": [
		"./src/app/pastorders/pastorders.module.ts",
		"pastorders-pastorders-module"
	],
	"../roledashboard/roledashboard.module": [
		"./src/app/roledashboard/roledashboard.module.ts",
		"roledashboard-roledashboard-module"
	],
	"../statisticks-folder/statisticks/statisticks.module": [
		"./src/app/statisticks-folder/statisticks/statisticks.module.ts",
		"statisticks-folder-statisticks-statisticks-module"
	],
	"../trader-order-show/trader-order-show.module": [
		"./src/app/trader-order-show/trader-order-show.module.ts"
	],
	"./../dealer/price-settings/price-settings.module": [
		"./src/app/dealer/price-settings/price-settings.module.ts",
		"price-settings-price-settings-module"
	],
	"./../inventory-detail/inventory-detail.module": [
		"./src/app/inventory-detail/inventory-detail.module.ts",
		"common",
		"inventory-detail-inventory-detail-module"
	],
	"./../inventory-info/inventory-info.module": [
		"./src/app/inventory-info/inventory-info.module.ts",
		"inventory-info-inventory-info-module"
	],
	"./../lease/lease-home/lease-home.module": [
		"./src/app/lease/lease-home/lease-home.module.ts",
		"lease-lease-home-lease-home-module"
	],
	"./../market-indicators/market-indicators.module": [
		"./src/app/market-indicators/market-indicators.module.ts",
		"market-indicators-market-indicators-module"
	],
	"./../myfarm-info/myfarm-info.module": [
		"./src/app/myfarm-info/myfarm-info.module.ts",
		"myfarm-info-myfarm-info-module"
	],
	"./../myfarmedit/myfarmedit.module": [
		"./src/app/myfarmedit/myfarmedit.module.ts",
		"myfarmedit-myfarmedit-module"
	],
	"./../poultry-home/poultry-home.module": [
		"./src/app/poultry-home/poultry-home.module.ts",
		"poultry-home-poultry-home-module"
	],
	"./../trader/lifting/lifting.module": [
		"./src/app/trader/lifting/lifting.module.ts",
		"default~AutomaticSystem-devices-dashboard-devices-dashboard-module~EC-Farm-Automate-ec-farm-create-e~df4b194d",
		"default~lifting-lifting-module~trader-lifting-lifting-module",
		"default~trader-lifting-lifting-module~trader-trader-module"
	],
	"./../trader/orders/orders.module": [
		"./src/app/trader/orders/orders.module.ts",
		"trader-orders-orders-module"
	],
	"./about-us/about-us.module": [
		"./src/app/about-us/about-us.module.ts",
		"about-us-about-us-module"
	],
	"./add-a-chikencenter/add-a-chikencenter.module": [
		"./src/app/trader/add-a-chikencenter/add-a-chikencenter.module.ts",
		"add-a-chikencenter-add-a-chikencenter-module"
	],
	"./add-farmer/add-farmer.module": [
		"./src/app/add-farmer/add-farmer.module.ts",
		"add-farmer-add-farmer-module"
	],
	"./addfarmer-supervisor/addfarmer-supervisor.module": [
		"./src/app/addfarmer-supervisor/addfarmer-supervisor.module.ts",
		"addfarmer-supervisor-addfarmer-supervisor-module"
	],
	"./address-list/address-list.module": [
		"./src/app/products/address-list/address-list.module.ts",
		"common",
		"address-list-address-list-module"
	],
	"./centers/centers.module": [
		"./src/app/trader/centers/centers.module.ts",
		"default~AutomaticSystem-devices-dashboard-devices-dashboard-module~EC-Farm-Automate-ec-farm-create-e~df4b194d",
		"centers-centers-module"
	],
	"./chicken-center-add/chicken-center-add.module": [
		"./src/app/chicken-center-add/chicken-center-add.module.ts",
		"chicken-center-add-chicken-center-add-module"
	],
	"./chicken-center-home/chicken-center-home.module": [
		"./src/app/chicken-center-home/chicken-center-home.module.ts",
		"chicken-center-home-chicken-center-home-module"
	],
	"./chicken-center/chicken-center.module": [
		"./src/app/chicken-center/chicken-center.module.ts",
		"chicken-center-chicken-center-module"
	],
	"./chicken-home/chicken-home.module": [
		"./src/app/chicken-center-home/chicken-home/chicken-home.module.ts",
		"default~AutomaticSystem-devices-dashboard-devices-dashboard-module~EC-Farm-Automate-ec-farm-create-e~df4b194d",
		"chicken-home-chicken-home-module"
	],
	"./create-order/create-order.module": [
		"./src/app/create-order/create-order.module.ts",
		"create-order-create-order-module"
	],
	"./dealer-review/dealer-review.module": [
		"./src/app/dealer-review/dealer-review.module.ts",
		"dealer-review-dealer-review-module"
	],
	"./dealer/dealer.module": [
		"./src/app/dealer/dealer.module.ts",
		"dealer-dealer-module"
	],
	"./delivery/delivery.module": [
		"./src/app/products/delivery/delivery.module.ts",
		"delivery-delivery-module"
	],
	"./disclaimer/disclaimer.module": [
		"./src/app/disclaimer/disclaimer.module.ts",
		"disclaimer-disclaimer-module"
	],
	"./fcr/fcr.module": [
		"./src/app/home/fcr/fcr.module.ts",
		"fcr-fcr-module"
	],
	"./forgotpassword/forgotpassword.module": [
		"./src/app/forgotpassword/forgotpassword.module.ts",
		"common",
		"forgotpassword-forgotpassword-module"
	],
	"./google-maps-show/google-maps-show.module": [
		"./src/app/google-maps-show/google-maps-show.module.ts",
		"default~AutomaticSystem-devices-dashboard-devices-dashboard-module~EC-Farm-Automate-ec-farm-create-e~df4b194d",
		"google-maps-show-google-maps-show-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"common",
		"home-home-module"
	],
	"./home/inventory/inventory.module": [
		"./src/app/home/inventory/inventory.module.ts"
	],
	"./home/myfarm/myfarm.module": [
		"./src/app/home/myfarm/myfarm.module.ts"
	],
	"./homefarm-view/homefarm-view.module": [
		"./src/app/homefarm-view/homefarm-view.module.ts",
		"homefarm-view-homefarm-view-module"
	],
	"./infopage/infopage.module": [
		"./src/app/infopage/infopage.module.ts",
		"infopage-infopage-module"
	],
	"./inventory/inventory.module": [
		"./src/app/home/inventory/inventory.module.ts"
	],
	"./layer-farmer/layer-farmer.module": [
		"./src/app/layer-farmer/layer-farmer.module.ts",
		"layer-farmer-layer-farmer-module"
	],
	"./layers-inventory/layers-inventory-create/layers-inventory-create.module": [
		"./src/app/layers-inventory/layers-inventory-create/layers-inventory-create.module.ts",
		"layers-inventory-layers-inventory-create-layers-inventory-create-module"
	],
	"./lease/lease-home/lease-home.module": [
		"./src/app/lease/lease-home/lease-home.module.ts",
		"lease-lease-home-lease-home-module"
	],
	"./lease/lease/lease.module": [
		"./src/app/lease/lease/lease.module.ts"
	],
	"./lifting-dcs/lifting-dcs.module": [
		"./src/app/lifting-dcs/lifting-dcs.module.ts",
		"lifting-dcs-lifting-dcs-module"
	],
	"./lifting-docs/lifting-docs.module": [
		"./src/app/trader-van-home/lifting-docs/lifting-docs.module.ts",
		"lifting-docs-lifting-docs-module"
	],
	"./lifting-supervisor/lifting-supervisor.module": [
		"./src/app/lifting-supervisor/lifting-supervisor.module.ts",
		"lifting-supervisor-lifting-supervisor-module"
	],
	"./lifting-vans/lifting-vans.module": [
		"./src/app/lifting-vans/lifting-vans.module.ts",
		"lifting-vans-lifting-vans-module"
	],
	"./liftings-farmer/liftings-farmer.module": [
		"./src/app/liftings-farmer/liftings-farmer.module.ts",
		"liftings-farmer-liftings-farmer-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"common",
		"login-login-module"
	],
	"./market-indicators-graph-view/market-indicators-graph-view.module": [
		"./src/app/market-indicators-graph-view/market-indicators-graph-view.module.ts",
		"market-indicators-graph-view-market-indicators-graph-view-module"
	],
	"./market-indicators/market-indicators.module": [
		"./src/app/market-indicators/market-indicators.module.ts",
		"market-indicators-market-indicators-module"
	],
	"./myfarm-info/myfarm-info.module": [
		"./src/app/myfarm-info/myfarm-info.module.ts",
		"myfarm-info-myfarm-info-module"
	],
	"./myfarm/myfarm.module": [
		"./src/app/home/myfarm/myfarm.module.ts"
	],
	"./notifications/notifications.module": [
		"./src/app/notifications/notifications.module.ts",
		"default~AutomaticSystem-devices-dashboard-devices-dashboard-module~EC-Farm-Automate-ec-farm-create-e~df4b194d",
		"notifications-notifications-module"
	],
	"./otp/otp.module": [
		"./src/app/otp/otp.module.ts"
	],
	"./pastorders/pastorders.module": [
		"./src/app/pastorders/pastorders.module.ts",
		"pastorders-pastorders-module"
	],
	"./payment/payment.module": [
		"./src/app/products/payment/payment.module.ts",
		"common",
		"payment-payment-module"
	],
	"./poultry-home/poultry-home.module": [
		"./src/app/poultry-home/poultry-home.module.ts",
		"poultry-home-poultry-home-module"
	],
	"./price-settings/price-settings.module": [
		"./src/app/dealer/price-settings/price-settings.module.ts",
		"price-settings-price-settings-module"
	],
	"./products-list/products-list.module": [
		"./src/app/products/products-list/products-list.module.ts",
		"common",
		"products-list-products-list-module"
	],
	"./products/add-new-card/add-new-card.module": [
		"./src/app/products/add-new-card/add-new-card.module.ts",
		"products-add-new-card-add-new-card-module"
	],
	"./products/ordered-list/ordered-list.module": [
		"./src/app/products/ordered-list/ordered-list.module.ts",
		"products-ordered-list-ordered-list-module"
	],
	"./products/payment-cards-detail/payment-cards-detail.module": [
		"./src/app/products/payment-cards-detail/payment-cards-detail.module.ts",
		"products-payment-cards-detail-payment-cards-detail-module"
	],
	"./products/payment/payment.module": [
		"./src/app/products/payment/payment.module.ts",
		"common",
		"payment-payment-module"
	],
	"./products/produc-notfications/produc-notfications.module": [
		"./src/app/products/produc-notfications/produc-notfications.module.ts",
		"products-produc-notfications-produc-notfications-module"
	],
	"./products/products-list/products-list.module": [
		"./src/app/products/products-list/products-list.module.ts",
		"common",
		"products-list-products-list-module"
	],
	"./products/products.module": [
		"./src/app/products/products.module.ts",
		"common",
		"products-products-module"
	],
	"./profile/changepassword/changepassword.module": [
		"./src/app/profile/changepassword/changepassword.module.ts",
		"common",
		"profile-changepassword-changepassword-module"
	],
	"./profile/edit-profile/edit-profile.module": [
		"./src/app/profile/edit-profile/edit-profile.module.ts",
		"profile-edit-profile-edit-profile-module"
	],
	"./profile/user-edit-info/user-edit-info.module": [
		"./src/app/profile/user-edit-info/user-edit-info.module.ts",
		"profile-user-edit-info-user-edit-info-module"
	],
	"./profile/user-profile/user-profile.module": [
		"./src/app/profile/user-profile/user-profile.module.ts",
		"profile-user-profile-user-profile-module"
	],
	"./register/register.module": [
		"./src/app/register/register.module.ts",
		"default~modal-address-search-address-search-module~register-register-module",
		"register-register-module"
	],
	"./resetpassword/resetpassword.module": [
		"./src/app/resetpassword/resetpassword.module.ts",
		"common",
		"resetpassword-resetpassword-module"
	],
	"./ricehusk-review/ricehusk-review.module": [
		"./src/app/ricehusk-review/ricehusk-review.module.ts",
		"ricehusk-review-ricehusk-review-module"
	],
	"./ricehusk-review2/ricehusk-review2.module": [
		"./src/app/ricehusk-review2/ricehusk-review2.module.ts",
		"ricehusk-review2-ricehusk-review2-module"
	],
	"./ricehusk/ricehusk.module": [
		"./src/app/ricehusk/ricehusk.module.ts",
		"ricehusk-ricehusk-module"
	],
	"./risehusk-preview/risehusk-preview.module": [
		"./src/app/risehusk-preview/risehusk-preview.module.ts",
		"risehusk-preview-risehusk-preview-module"
	],
	"./settings/settings.module": [
		"./src/app/products/settings/settings.module.ts",
		"settings-settings-module"
	],
	"./shopping-cart/shopping-cart.module": [
		"./src/app/products/shopping-cart/shopping-cart.module.ts",
		"common",
		"shopping-cart-shopping-cart-module"
	],
	"./shownotifications/shownotifications.module": [
		"./src/app/shownotifications/shownotifications.module.ts",
		"shownotifications-shownotifications-module"
	],
	"./superviso-farmer-details/superviso-farmer-details.module": [
		"./src/app/superviso-farmer-details/superviso-farmer-details.module.ts",
		"superviso-farmer-details-superviso-farmer-details-module"
	],
	"./supervisor-farms-list/supervisor-farms-list.module": [
		"./src/app/supervisor-farms-list/supervisor-farms-list.module.ts",
		"common",
		"supervisor-farms-list-supervisor-farms-list-module"
	],
	"./supervisor-home/supervisor-home.module": [
		"./src/app/supervisor-home/supervisor-home.module.ts",
		"supervisor-home-supervisor-home-module"
	],
	"./supervisorfarmdetail/supervisorfarmdetail.module": [
		"./src/app/supervisorfarmdetail/supervisorfarmdetail.module.ts",
		"supervisorfarmdetail-supervisorfarmdetail-module"
	],
	"./trader-add-van/trader-add-van.module": [
		"./src/app/trader-add-van/trader-add-van.module.ts",
		"trader-add-van-trader-add-van-module"
	],
	"./trader-chicken-center-show/trader-chicken-center-show.module": [
		"./src/app/trader-chicken-center-show/trader-chicken-center-show.module.ts",
		"trader-chicken-center-show-trader-chicken-center-show-module"
	],
	"./trader-details/trader-details.module": [
		"./src/app/trader-details/trader-details.module.ts",
		"trader-details-trader-details-module"
	],
	"./trader-farm/trader-farm.module": [
		"./src/app/trader-farm/trader-farm.module.ts",
		"default~trader-farm-trader-farm-module~trader-trader-module"
	],
	"./trader-home/trader-home.module": [
		"./src/app/trader/trader-home/trader-home.module.ts",
		"trader-home-trader-home-module"
	],
	"./trader-info/trader-info.module": [
		"./src/app/trader-info/trader-info.module.ts",
		"trader-info-trader-info-module"
	],
	"./trader-message/trader-message.module": [
		"./src/app/trader-message/trader-message.module.ts",
		"trader-message-trader-message-module"
	],
	"./trader-order-show/trader-order-show.module": [
		"./src/app/trader-order-show/trader-order-show.module.ts"
	],
	"./trader-ratings/trader-ratings.module": [
		"./src/app/trader-ratings/trader-ratings.module.ts",
		"trader-ratings-trader-ratings-module"
	],
	"./trader-settings/trader-settings.module": [
		"./src/app/trader-settings/trader-settings.module.ts",
		"trader-settings-trader-settings-module"
	],
	"./trader-van-home/trader-van-home.module": [
		"./src/app/trader-van-home/trader-van-home.module.ts",
		"trader-van-home-trader-van-home-module"
	],
	"./trader-van-home/van-history/van-history.module": [
		"./src/app/trader-van-home/van-history/van-history.module.ts",
		"trader-van-home-van-history-van-history-module"
	],
	"./trader-van-show/trader-van-show.module": [
		"./src/app/trader-van-show/trader-van-show.module.ts",
		"trader-van-show-trader-van-show-module"
	],
	"./trader/trader.module": [
		"./src/app/trader/trader.module.ts",
		"default~trader-lifting-lifting-module~trader-trader-module",
		"default~trader-farm-trader-farm-module~trader-trader-module",
		"common",
		"trader-trader-module"
	],
	"./van-details/van-details.module": [
		"./src/app/van-details/van-details.module.ts",
		"van-details-van-details-module"
	],
	"./van-home/van-home.module": [
		"./src/app/trader-van-home/van-home/van-home.module.ts",
		"default~AutomaticSystem-devices-dashboard-devices-dashboard-module~EC-Farm-Automate-ec-farm-create-e~df4b194d",
		"van-home-van-home-module"
	],
	"./vehicle-driver/vehicle-driver.module": [
		"./src/app/vehicle-driver/vehicle-driver.module.ts",
		"vehicle-driver-vehicle-driver-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;